// removed by extract-text-webpack-plugin
module.exports = {"Dbtn":"DecorativeButton__Dbtn__2VQ4q"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/DecorativeButton/DecorativeButton.css
// module id = 290
// module chunks = 0